<div id="root-container">

    <app-tool-bar></app-tool-bar>
    <div class="app-content">
        <router-outlet></router-outlet>

    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html